<template>
    <div class="row">
        <div v-if="isFormValid" class="small-12 columns">
            Vielen Dank für Ihre Angaben. Bitte klicken Sie auf Abschicken um Ihr Schreiben an die Bank zu generieren.
        </div>
        <div v-else class="small-12 columns">
            Bitte füllen Sie das Formular vollständig aus.
        </div>
    </div>
</template>

<script>

export default {
    name: 'FinalStep',
    props: {
        isFormValid: Boolean
    }
};
</script>

<style scoped>
    .row div {
        top: 100px;
        text-align: center;
    }
</style>